import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { FeatureName } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import * as Layout from 'layouts/ContentLayout';

import AccountClosure from './Pages/AccountClosure';
import CompanyProfile from './Pages/CompanyProfile';
import * as routes from './routes';

const CompanyRoutes: FC = () => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  return (
    <Layout.Root>
      <Layout.Body>
        <Switch>
          <Route component={CompanyProfile} exact path={routes.root} />

          {canAccessFeature({ name: FeatureName.CompanyClose }) ? (
            <Route component={AccountClosure} path={routes.accountClosure} />
          ) : null}

          <Route path="*">
            <Redirect to={routes.root} />
          </Route>
        </Switch>
      </Layout.Body>
    </Layout.Root>
  );
};

export default CompanyRoutes;
